/**
 * Минимум от канвасного контекста, нужный для отрисовки строки. Описан
 * структурно нарочно: в постах это CanvasRenderingContext2D, в рилсах —
 * OffscreenCanvasRenderingContext2D, а код деления цвета у них общий.
 */
export interface TextDrawContext {
  textAlign: CanvasTextAlign;
  fillStyle: unknown;
  measureText(text: string): { width: number };
  fillText(text: string, x: number, y: number): void;
}

/**
 * Рисует строку двумя цветами: первые `chars` символов — `head`, остальное — `tail`.
 *
 * Нужно потому, что граница цвета в макете Alash проходит ПОСРЕДИ строки —
 * бирюзовая фраза кончается на двоеточии, и белый текст идёт дальше в той же
 * строке. Построчной покраски для этого не хватает.
 *
 * Выравнивание учитывается: при center/right сначала вычисляем левый край
 * строки целиком, а обе половины рисуем уже от него влево-направо. Иначе
 * каждая половина центровалась бы сама по себе и они наложились бы друг на друга.
 */
export function fillTextSplit(
  ctx: TextDrawContext,
  line: string,
  x: number,
  y: number,
  chars: number,
  head: string,
  tail: string,
): void {
  if (chars <= 0) {
    ctx.fillStyle = tail;
    ctx.fillText(line, x, y);
    return;
  }
  if (chars >= line.length) {
    ctx.fillStyle = head;
    ctx.fillText(line, x, y);
    return;
  }
  const align = ctx.textAlign;
  const total = ctx.measureText(line).width;
  const left = align === 'center' ? x - total / 2 : align === 'right' ? x - total : x;
  const headText = line.slice(0, chars);
  ctx.textAlign = 'left';
  ctx.fillStyle = head;
  ctx.fillText(headText, left, y);
  ctx.fillStyle = tail;
  ctx.fillText(line.slice(chars), left + ctx.measureText(headText).width, y);
  ctx.textAlign = align;
}
